
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as carts4NJL_45Kk31Yog9qQqiefJB7l_456oB33nqoLcb7v1TNRUMeta } from "/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/cart.vue?macro=true";
import { default as homeHDJOCI4iQOGXhNZX1TDXt6VM_454AkQAcdIYqCWx9V__gMeta } from "/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/home.vue?macro=true";
import { default as indexppGs_451Dh1BjUgoRB_dhCHYrKxMRazNYpUhEG75Lu54EMeta } from "/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/index.vue?macro=true";
import { default as paymentjtNyFfVVz2vW6W8jGe6IcueU8X4OjE3Z_45CQQ99SwixsMeta } from "/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/payment.vue?macro=true";
import { default as profileFbSS64ssBv0P5ZZ8Z0lwHVtWpmyiXe9GdpgZgVB3lz4Meta } from "/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/profile.vue?macro=true";
import { default as checkout3rqzNPRtZjN6yXGBhV07XLYMSKu8Ggk01iA1VkCJaT8Meta } from "/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/checkout.vue?macro=true";
import { default as thankyounS0Q_450lexvvdYPy5S2MrPDsh7VQqerSPqiSALuwqSC8Meta } from "/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/thankyou.vue?macro=true";
import { default as wishlistq4t9JSC7wIW4Lk7wMTA_457j9sMvrF3aHrK7GkVgpb6uMMeta } from "/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/wishlist.vue?macro=true";
import { default as notificationsh6Mc2V6D6Hx8mHD_kP4BDaDyGekGMrYbBTvZbfLECAgMeta } from "/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/notifications.vue?macro=true";
import { default as indexJfjfLFuRNwPmTPeyq5UXn6gKbKB1CN4X2t_45_45r0_Vr_45EMeta } from "/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/rewards/index.vue?macro=true";
import { default as _91slug_93YMdXhaMj2NHe1KDF7m4QVqonpvPKLM8j8oXE_45V6IGNYMeta } from "/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/static/[slug].vue?macro=true";
import { default as points_45history_45LqpsxQXxV15df_o0Vc77KusazJqVfFrqDM32RiS_454UMeta } from "/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/points-history.vue?macro=true";
import { default as refer_45and_45earnr3YbQkJiNMri6iOZhI9sR6Fe9FSdQlO__I6mypDUTAcMeta } from "/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/refer-and-earn.vue?macro=true";
import { default as _91id_93eZiY6lv4s9TelWlc8tOCtfdewoPOMVIxiclgHMIqKNEMeta } from "/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/order-history/[id].vue?macro=true";
import { default as indexSlLDC2wG_45IdqLaoeVxTeofdcDen1qeYj_45AVcxBdfjvkMeta } from "/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/order-history/index.vue?macro=true";
import { default as indexUAjEwfTVATP382tIkZwwjM1_45YglDipge9DMObm23Y8QMeta } from "/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/retailpartners/index.vue?macro=true";
import { default as _91id_935w10D8bgCoEx3Y13NogrhYXh7BU_H1OMUXiJ64_45zUT0Meta } from "/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/rewards/details/[id].vue?macro=true";
import { default as indexExHiuep_EqOQgukKC4Z2GVG_45gWyuUP8kQDiYk7pxQcMMeta } from "/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/payment-history/index.vue?macro=true";
import { default as payment_45details6LZXfH2IYqoxMImp8E2oVGvX9aAXY6S2IWTj_45EmnftcMeta } from "/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/payment-history/payment-details.vue?macro=true";
export default [
  {
    name: "cart",
    path: "/cart",
    meta: carts4NJL_45Kk31Yog9qQqiefJB7l_456oB33nqoLcb7v1TNRUMeta || {},
    component: () => import("/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/cart.vue")
  },
  {
    name: "home",
    path: "/home",
    meta: homeHDJOCI4iQOGXhNZX1TDXt6VM_454AkQAcdIYqCWx9V__gMeta || {},
    component: () => import("/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/home.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexppGs_451Dh1BjUgoRB_dhCHYrKxMRazNYpUhEG75Lu54EMeta || {},
    component: () => import("/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/index.vue")
  },
  {
    name: "payment",
    path: "/payment",
    meta: paymentjtNyFfVVz2vW6W8jGe6IcueU8X4OjE3Z_45CQQ99SwixsMeta || {},
    component: () => import("/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/payment.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: profileFbSS64ssBv0P5ZZ8Z0lwHVtWpmyiXe9GdpgZgVB3lz4Meta || {},
    component: () => import("/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/profile.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    meta: checkout3rqzNPRtZjN6yXGBhV07XLYMSKu8Ggk01iA1VkCJaT8Meta || {},
    component: () => import("/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/checkout.vue")
  },
  {
    name: "thankyou",
    path: "/thankyou",
    component: () => import("/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/thankyou.vue")
  },
  {
    name: "wishlist",
    path: "/wishlist",
    component: () => import("/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/wishlist.vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    component: () => import("/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/notifications.vue")
  },
  {
    name: "rewards",
    path: "/rewards",
    meta: indexJfjfLFuRNwPmTPeyq5UXn6gKbKB1CN4X2t_45_45r0_Vr_45EMeta || {},
    component: () => import("/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/rewards/index.vue")
  },
  {
    name: "static-slug",
    path: "/static/:slug()",
    component: () => import("/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/static/[slug].vue")
  },
  {
    name: "points-history",
    path: "/points-history",
    component: () => import("/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/points-history.vue")
  },
  {
    name: "refer-and-earn",
    path: "/refer-and-earn",
    meta: refer_45and_45earnr3YbQkJiNMri6iOZhI9sR6Fe9FSdQlO__I6mypDUTAcMeta || {},
    component: () => import("/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/refer-and-earn.vue")
  },
  {
    name: "order-history-id",
    path: "/order-history/:id()",
    component: () => import("/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/order-history/[id].vue")
  },
  {
    name: "order-history",
    path: "/order-history",
    component: () => import("/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/order-history/index.vue")
  },
  {
    name: "retailpartners",
    path: "/retailpartners",
    meta: indexUAjEwfTVATP382tIkZwwjM1_45YglDipge9DMObm23Y8QMeta || {},
    component: () => import("/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/retailpartners/index.vue")
  },
  {
    name: "rewards-details-id",
    path: "/rewards/details/:id()",
    meta: _91id_935w10D8bgCoEx3Y13NogrhYXh7BU_H1OMUXiJ64_45zUT0Meta || {},
    component: () => import("/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/rewards/details/[id].vue")
  },
  {
    name: "payment-history",
    path: "/payment-history",
    component: () => import("/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/payment-history/index.vue")
  },
  {
    name: "payment-history-payment-details",
    path: "/payment-history/payment-details",
    component: () => import("/codebuild/output/src4179297151/src/hyp-loyalty-frontend/pages/payment-history/payment-details.vue")
  }
]